var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"location",class:{ wide: _vm.wide },attrs:{"href":_vm.mapLink,"target":"_blank","rel":"noopener noreferrer","aria-label":_vm.linkAriaLabel}},[_c('LMap',{attrs:{"zoom":_vm.previewZoom,"center":_vm.center,"options":{
			scrollWheelZoom: false,
			zoomControl: false,
			dragging: false,
			attributionControl: false,
		}},on:{"scroll":function($event){$event.preventDefault();}}},[_c('LTileLayer',{attrs:{"url":_vm.url}}),_vm._v(" "),_c('LControlAttribution',{attrs:{"position":"bottomright","prefix":_vm.attribution}}),_vm._v(" "),_c('LMarker',{attrs:{"lat-lng":_vm.center}},[_c('LTooltip',{attrs:{"options":{
				direction: 'top',
				permanent: 'true',
				offset: [-16, -14],
			}}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.name)+"\n\t\t\t")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }